// extracted by mini-css-extract-plugin
export var actionButton = "_ir-t";
export var buttonContainer = "_ir-0";
export var buttonContainer2 = "_ir-1";
export var buttonSection = "_ir-2";
export var details = "_ir-3";
export var dropdownItem = "_ir-5";
export var dropdownItemsContainer = "_ir-4";
export var fileInput = "_ir-r";
export var headerButton = "_ir-6";
export var icon = "_ir-7";
export var input = "_ir-8";
export var macroListItem = "_ir-9";
export var mainContent = "_ir-a";
export var microText = "_ir-b";
export var modal = "_ir-w";
export var optionsButton = "_ir-c";
export var paperclip = "_ir-s";
export var pillContent = "_ir-d";
export var preview = "_ir-e";
export var preview2 = "_ir-f";
export var quillEditor = "_ir-q";
export var selectedMacro = "_ir-g";
export var sidebar = "_ir-h";
export var sidebarHeader = "_ir-j";
export var sidebarList = "_ir-i";
export var sidebarListItem = "_ir-k";
export var sidebarSearch = "_ir-l";
export var snoozeDurationWrapper = "_ir-v";
export var statusPillContainer = "_ir-m";
export var tagsContainer = "_ir-n";
export var unselectedMacro = "_ir-o";
export var variable = "_ir-u";
export var wrapper = "_ir-p";